import React from 'react';
import style from './Table.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

interface CompProps {
  columns: string[];
  data: any;
  csv?: string;
}

const Table = ({ columns, data, csv }: CompProps): React.ReactElement => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('new');
  };
  const handleValue = (val: any) => {
    if (val === 'true') {
      return <i className={`bi bi-check-circle-fill ${style.greenIcon}`} />;
    } else if (val === 'false') {
      return <i className={`bi bi-x-circle-fill ${style.redIcon}`} />;
    } else {
      return val;
    }
  };

  const handleDownload = () => {
    if (!csv) return;
    const element = document.createElement('a');
    element.href = csv;
    element.download = 'data.csv';
    element.click();
  };

  return (
    <div className={style.container}>
      {columns[1] === 'Email' ? (
        <Button className={style.downloadButton} variant="success" onClick={handleDownload}>
          Download
        </Button>
      ) : (
        <Button className={style.button} variant="success" onClick={handleClick}>
          +
        </Button>
      )}
      <table className={style.table}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column}> {column} </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((obj: any, idx: number) => (
            <tr key={`${idx}`}>
              {Object.values(obj).map((val: any, idx2: number) =>
                Array.isArray(val) ? (
                  <td key={`${idx} ${idx2}`}>
                    {val.map((subvalue: string | number, idx3: number) => (
                      <div key={`${idx} ${idx2} ${idx3}`}>
                        <div>{subvalue}</div>
                        {idx3 !== val.length - 1 && <br />}
                      </div>
                    ))}
                  </td>
                ) : idx2 === 1 ? (
                  <td key={`${idx} ${idx2}`} className={`${style.row}`}>
                    <Link className={style.link} to={`${obj.id}`}>
                      {val}
                    </Link>
                  </td>
                ) : (
                  <td key={`${idx} ${idx2}`} className={`${style.row} ${idx}`}>
                    {handleValue(val)}
                  </td>
                )
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
